// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"c9436c10","355":"e93f8225","357":"221bff9f","488":"320dd8ff","533":"9beb3a55","604":"696a8d7d","843":"e40d9c36","914":"e446921b"}[chunkId] + ".chunk.js";
};